import { toast } from "react-toastify";
import { getBaseURL } from "../lib/axiosConfig";

export async function retry<T>(
  fn: () => Promise<T>,
  retries: number = 3,
  delayMs: number = 500
): Promise<T> {
  let lastError: any;

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      toast.error(`Falha, tentando novamente, tentativa ${attempt} de ${retries}`, {
        autoClose: delayMs
      })
      lastError = error;
      if (attempt < retries) {
        await new Promise(res => setTimeout(res, delayMs));
      }
    }
  }

  throw lastError;
}

export const createMQTTSubscriber = (totemId: string) => {
  const baseUrl = getBaseURL();
  const token = localStorage.getItem("authToken");

  const url = new URL(`/api/v1/sse/confirmation/${totemId}`, baseUrl);

  if (token) {
    url.searchParams.set("token", token);
  }

  return new EventSource(url.toString());
};
